/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Group_Image_DefaultInputs */

const vi_shop_group_image_default = /** @type {(inputs: Shop_Group_Image_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mặc định`)
};

/**

* @param {Shop_Group_Image_DefaultInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_group_image_default = /** @type {((inputs?: Shop_Group_Image_DefaultInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Group_Image_DefaultInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_group_image_default(inputs)
});